import { store } from "../../redux/store";
import { selectors as brandSelectors } from "../../redux/brand";
import { selectors as routerSelectors } from "../../redux/router";
import { safeRedirect } from "./location";
import { toastUtils } from "../../utils/toast-utils";
import { t } from "../../ui/core/translate";
import {
  isiOS,
  isAndroid,
  isChromebook,
  isSafari,
  isInIframe
} from "./browser";
import { largeMobileMediaQuery } from "../components/mediaquery/breakpoints";

export const shouldShowReadOffline = (skipChrome = false) => {
  const state = store.getState();

  const showReadOffline = brandSelectors.getBrandValue(
    state,
    "ReadOffline.visible"
  );
  const readOfflineIosUrl = brandSelectors.getBrandValue(
    state,
    "ReadOffline.ios_url"
  );
  const readOfflineAndroidUrl = brandSelectors.getBrandValue(
    state,
    "ReadOffline.android_url"
  );
  const readOfflineChromeUrl = brandSelectors.getBrandValue(
    state,
    "ReadOffline.chrome_url"
  );
  const readOfflineUrl = brandSelectors.getBrandValue(state, "ReadOffline.url");
  return (
    showReadOffline &&
    ((isiOS() && readOfflineIosUrl) ||
      (isAndroid() && readOfflineAndroidUrl) ||
      (isChromebook() && readOfflineChromeUrl && !skipChrome) ||
      (!isiOS() && !isAndroid() && !isChromebook() && readOfflineUrl))
  );
};

const _getAppURL = () => {
  let url;
  if (!isSafari() || isiOS()) {
    if (isiOS()) {
      url = brandSelectors.getBrandValue(
        store.getState(),
        "ReadOffline.ios_url"
      );
    } else if (isAndroid()) {
      url = brandSelectors.getBrandValue(
        store.getState(),
        "ReadOffline.android_url"
      );
    } else if (isChromebook()) {
      url = brandSelectors.getBrandValue(
        store.getState(),
        "ReadOffline.chrome_url"
      );
    } else {
      url = brandSelectors.getBrandValue(store.getState(), "ReadOffline.url");
    }
  } else {
    url = brandSelectors.getBrandValue(store.getState(), "ReadOffline.url");
  }
  return url;
};

export const downloadApp = e => {
  e.preventDefault();
  const url = _getAppURL();
  if (!isSafari() || isAndroid()) {
    if (isiOS()) {
      safeRedirect(url, "_top");
    } else {
      if (!safeRedirect(url, "_blank")) {
        safeRedirect(url);
      }
    }
  } else {
    safeRedirect(url, "_blank");
  }
};

const launchAppURL = url => {
  Jigsaw.User.SSO({ destination: url }, function (response) {
    if (response.isSuccess()) {
      if (isInIframe()) {
        toastUtils.notify(t("sso.popup"));
        window.open(response.data.redirect.autoSignin, "_blank");
      } else if (isAndroid() || isiOS()) {
        window.location = response.data.redirect.autoSignin;
      } else {
        $("body").append(
          $(
            "<iframe id='read-offline-iframe' style='display:none;' src='" +
              response.data.redirect.autoSignin +
              "'></iframe>"
          )
        );
      }
    } else window.location = url;
  });
};

export const launchInApp = isbn => {
  // if (Fraction.Helpers.Browser.isChromebook() && Fraction.Brand.ReadOffline.chrome_url) {
  // No chromebook for nooooow
  // this.launchInChromeApp();
  // } else {
  const protocol = brandSelectors.getBrandValue(
    store.getState(),
    "ReadOffline.protocol"
  );
  let url = protocol + "bookshelf";
  if (isbn) {
    url = protocol + isbn;
    if (false) {
      // TODO deep linking into isbn
      /*
        Fraction.Viewer.Book.getUniversalURL(function(response){
          if (response.isSuccess()){
            url = Fraction.Brand.ReadOffline.protocol+response.data.url.substring(7);
          }
          Fraction.Helpers.launchAppURL(url);
        });
        */
    } else {
      launchAppURL(url);
    }
  } else {
    launchAppURL(url);
  }
};

export const showInterstitialScreen = () => {
  const state = store.getState();
  const isNative = routerSelectors.isNative(state);

  if (!isNative && (isAndroid() || isiOS())) {
    if (shouldShowReadOffline(true)) {
      return true;
    }
    if (
      !shouldShowReadOffline(true) &&
      !window.matchMedia(largeMobileMediaQuery).matches
    ) {
      return true;
    }
  }
  return false;
};
